import { isValidImageReference } from "./isValidImageReference";

type ImageVerificationOptions = {
  checkNetwork?: boolean;
  checkStatus?: boolean;
  checkMime?: boolean;
  timeoutMs?: number;
};

export const verifyImageAvailability = async (
  value: unknown,
  options: ImageVerificationOptions,
): Promise<boolean> => {
  if (!isValidImageReference(value)) return false;

  const {
    checkNetwork = false,
    checkStatus = false,
    checkMime = false,
    timeoutMs = 3000,
  } = options;

  if (!checkNetwork && !checkStatus && !checkMime) {
    return true;
  }

  const controller = new AbortController();
  const id = setTimeout(() => controller.abort(), timeoutMs);

  try {
    const res = await fetch(value as string, {
      method: "HEAD",
      signal: controller.signal,
    });

    if (checkStatus && !res.ok) return false;

    if (checkMime) {
      const type = res.headers.get("content-type") || "";

      if (!type.startsWith("image/")) return false;
    }

    return true;
  } catch (error) {
    return false;
  } finally {
    clearTimeout(id);
  }
};
